import { getElementsToHide, removeBackdrop } from './searchModalUtils.js';
import { addSearchButtonEventListener } from './searchButtonEventListeners.js';

(function () {
    "use strict";

    const initializeGlobalSearch = () => {
        const searchButton = document.querySelector('.csh-aem-base-header__button--search');
        const elementsToHide = getElementsToHide();

        if (!searchButton) {
            return;
        }

        const observer = new MutationObserver(removeBackdrop);
        observer.observe(document.body, { childList: true });

        addSearchButtonEventListener(searchButton, elementsToHide);
    }

    document.addEventListener('DOMContentLoaded', () => {
        initializeGlobalSearch();
    });

})();